import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslations from 'i18n/locales/en.json'
import esTranslations from 'i18n/locales/es.json'
import frTranslations from 'i18n/locales/fr.json'
import { DEFAULT_LANGUAGE } from 'i18n/config'

const resources = {
  en: {
    translation: enTranslations
  },
  es: {
    translation: esTranslations
  },
  fr: {
    translation: frTranslations
  }
}

const i18nConfig = {
  resources,
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: 'translation',
  interpolation: {
    escapeValue: false // React already escapes values
  },
  react: {
    useSuspense: false
  }
}

// Initialize with English by default
i18nConfig.lng = DEFAULT_LANGUAGE

// Always add LanguageDetector (it's safe to add even if we don't use detection)
i18n.use(LanguageDetector)

// Initialize i18n with default config
i18n
  .use(initReactI18next)
  .init(i18nConfig)

// Function to update language - called from ConnectedI18nProvider
export const updateLanguage = (language, featureEnabled) => {
  if (!featureEnabled) {
    i18n.changeLanguage(DEFAULT_LANGUAGE)
    i18n.options.detection = undefined
    return
  }

  // Enable language detection if feature is enabled
  i18n.options.detection = {
    order: ['localStorage', 'navigator', 'htmlTag'],
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage']
  }

  // Use user preference if available and valid, otherwise detect from localStorage/navigator
  if (language && resources[language]) {
    i18n.changeLanguage(language)
  } else {
    // Fall back to detection
    let detectedLng = null
    if (typeof window !== 'undefined' && window.localStorage) {
      detectedLng = window.localStorage.getItem('i18nextLng')
    }
    if (!detectedLng && typeof window !== 'undefined' && window.navigator) {
      const navLang = window.navigator.language || window.navigator.userLanguage
      if (navLang) {
        detectedLng = navLang.split('-')[0]
      }
    }
    if (detectedLng && resources[detectedLng]) {
      i18n.changeLanguage(detectedLng)
    } else {
      i18n.changeLanguage(DEFAULT_LANGUAGE)
    }
  }
}

export default i18n
